<template>
  <div id="subHeader" class="padding-top-10 flex-row flex__between">
    <!-- <slot name="create"></slot>
    <slot name="search"></slot> -->
    <slot name="content"></slot>
  </div>
</template>

<script>
  export default {
    name: 'sub-header'
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/main/sub-header.vue